var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDecorationUxdoc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 52,
    viewBox: "0 0 47 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M40.619 0.562561V24.5396C40.619 24.6526 40.619 25.237 40.5995 26.0981C40.118 25.7347 39.6134 25.4028 39.0889 25.1045C36.4094 23.6078 33.3132 23.0261 30.2719 23.4481C27.2306 23.8701 24.4108 25.2727 22.2419 27.4422C20.1223 29.4927 18.7393 32.1837 18.3073 35.0982C18.1967 35.8438 18.1419 36.5965 18.1433 37.3502C18.0872 40.3978 19.0683 43.3743 20.9264 45.7932L20.9499 45.8244H16.8942C15.0655 45.8243 13.2669 45.3592 11.6681 44.473C10.0694 43.5869 8.72313 42.3088 7.75638 40.7593C6.6925 39.3239 6.11912 37.5851 6.12086 35.7995V0.539185H0.464844V36.4112C0.465879 40.382 2.04664 44.1898 4.8596 46.9976C7.67256 49.8053 11.4875 51.3832 15.4656 51.3842H46.2673V0.562561H40.619ZM23.8696 35.8424C24.1646 34.1503 24.9982 32.5982 26.2468 31.4163C26.3365 31.3228 26.4341 31.2332 26.5317 31.1436C27.725 30.0201 29.2369 29.2921 30.8606 29.0591C31.3027 28.9963 31.7489 28.965 32.1955 28.9656C34.2963 28.9619 36.3223 29.7432 37.8748 31.1558C39.4273 32.5685 40.3937 34.51 40.5839 36.5982C40.6034 36.8515 40.6151 37.1047 40.6151 37.3775V45.8205H32.215C29.9793 45.7971 27.8417 44.9 26.2611 43.3215C24.6805 41.7431 23.7826 39.6091 23.7603 37.3775C23.7515 36.8636 23.7881 36.3499 23.8696 35.8424Z",
    fill: "#663399"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M35.338 5.9276H11.4648V8.12893H35.338V5.9276Z",
    fill: "#663399"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M35.338 10.8445H11.4648V13.0459H35.338V10.8445Z",
    fill: "#663399"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M35.338 15.7653H11.4648V17.9667H35.338V15.7653Z",
    fill: "#663399"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecorationUxdoc);
export default __webpack_public_path__ + "static/media/decoration-uxdoc.963b9d233908c2f2c197e69ec25c9f9d.svg";
export { ForwardRef as ReactComponent };